import { render, staticRenderFns } from "./producto_crud.vue?vue&type=template&id=15f2cbe1&scoped=true"
import script from "./producto_crud.vue?vue&type=script&lang=js"
export * from "./producto_crud.vue?vue&type=script&lang=js"
import style0 from "./producto_crud.vue?vue&type=style&index=0&id=15f2cbe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2cbe1",
  null
  
)

export default component.exports